export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";